import fetch from 'cross-fetch';
import { CarlineWithOffers } from 'src';
import { getDataUrl } from '../get-data-url';
import { reportErrorSentry } from '../report-error-sentry';

export const fetchCarlineId = (carlineId: string): Promise<CarlineWithOffers> => {
  const dataUrl = getDataUrl();

  return fetch(dataUrl + '/' + 'getCarlineOfertas' + '/' + carlineId)
    .then((response) => response.json())
    .then((response) => response.carline)
    .catch(err => {
      reportErrorSentry(err);
    });
};
